import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getStorages } from "../../../../actions/productsActions";
import { storageFilter } from "../../../../helpers/functions";

const StorageAvailability = ({ productId }) => {
    const dispatch = useDispatch();
    const [storages, setStorages] = useState([]);

    useEffect(() => {
        if (!productId) return;

        let isActive = true;
        dispatch(getStorages(productId)).then(res => {
            if (!isActive) return;
            if (res.payload && res.payload.status === 200) {
                setStorages(storageFilter(res.payload.data));
            } else {
                setStorages([]);
            }
        });

        return () => {
            isActive = false;
        };
    }, [dispatch, productId]);

    if (storages !== null && storages.length > 0) {
        return (
            <table className="availability_table">
                <tr>
                    <th>Наличие на складах</th>
                    <th>Cтелаж</th>
                    <th>Ячейка</th>
                </tr>
                {storages.map((el, idx) => (
                    <tr className="row" key={idx}>
                        <td>{el.name}<span>({el.quantity} ед.)</span></td>
                        <td>{el.rack || '-'}</td>
                        <td>{el.cell || '-'}</td>
                    </tr>
                ))}
            </table>
        );
    }

    return (
        <div className="availability">
            <div className="descriptions">Наличие на складах</div>
            <div className="block">
                <span>Нет на складах</span>
            </div>
        </div>
    );
};

export default StorageAvailability;
